import { GET,POST } from "./api.js";

export const contactRoute = {
    generateCodeFunction: (data) => POST(`/contact/generate-code`, data),
    sendMessageContact: ( data) => POST(`/contact`, data),
}